import { cn } from "@/lib/utils";

export default function Marquee({ items, direction = "left", className = "" }) {
  const trackClass = direction === "left" ? "marquee-track-left" : "marquee-track-right";
  return (
    <div className={cn("relative overflow-hidden", className)} data-testid={`marquee-${direction}`}>
      <div className={cn("flex w-max gap-12", trackClass)}>
        {[...items, ...items].map((item, i) => (
          <span
            key={`${item}-${i}`}
            className="shrink-0 font-mono text-sm md:text-base text-zinc-500 hover:text-foreground transition uppercase tracking-wider"
          >
            {item}
          </span>
        ))}
      </div>
    </div>
  );
}
